import {PayloadAction} from "@reduxjs/toolkit";
import {all, delay, put, takeEvery} from "redux-saga/effects";
import isArray from "lodash/isArray";
import {
    ErrorMessage,
    ErrorPayload,
    ExtendedError,
    newError,
    playErrorSound,
    popError,
    pushError,
    Severity
} from "./errors";

import errorMp3 from "/assets/mp3/error.mp3";
import positiveMp3 from "/assets/mp3/positive.mp3";

const errorSound = new Audio(errorMp3);
const successSound = new Audio(positiveMp3);

function cleanError(e: ExtendedError): ErrorMessage {
    const ce: ErrorMessage = {message: "", severity: Severity.Error}
    if ("message" in e) {
        ce.message = e.message;
    }
    if ("msg" in e) {
        ce.message = e.msg;
    }
    if ("severity" in e) {
        ce.severity = e.severity;
    }

    return ce;
}

function* onNewError(action: PayloadAction<ErrorPayload>) {

    yield put(playErrorSound(Severity.Error))
    if (isArray(action.payload)) {
        for (let e of action.payload) {
            yield put(pushError(cleanError(e)));
            yield delay(5000);
            yield put(popError())
        }
    } else {
        yield put(pushError(cleanError(action.payload)))
        yield delay(5000);
        yield put(popError())
    }
}

function* onPlayErrorSound(action: PayloadAction<Severity>) {

    if (action.payload == Severity.Success) {
        successSound.play()
        return
    }
    errorSound.play()

}

export function* error_saga() {

    yield all([
        takeEvery(newError, onNewError),
        takeEvery(playErrorSound, onPlayErrorSound),
    ]);


}
